import { render, staticRenderFns } from "./TipMessage.vue?vue&type=template&id=ab23d1b8&scoped=true&"
import script from "./TipMessage.vue?vue&type=script&lang=js&"
export * from "./TipMessage.vue?vue&type=script&lang=js&"
import style0 from "./TipMessage.vue?vue&type=style&index=0&id=ab23d1b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab23d1b8",
  null
  
)

export default component.exports